import { jsx as a } from "react/jsx-runtime";
import { createContext as l, useContext as o, useCallback as v } from "react";
function L(t, e) {
  return t.startsWith("/") ? t : [e, t].filter((r) => !!r).join("/").replace(/^\/?/, "/");
}
function w(t, e) {
  return (r) => {
    let n = "";
    if (/^(https?:|mailto:|tel:)/.test(r))
      return r;
    n = L(r, t);
    const [m, d] = n.split("?"), i = new URLSearchParams(d);
    for (const [c, h] of e.entries())
      i.set(c, h);
    const u = i.toString() ? `?${i.toString()}` : "";
    return `${m}${u}`;
  };
}
const f = l(void 0), P = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "utm_id",
  "utm_campaign_id",
  "utm_gads",
  "fbclid",
  "gclid",
  "ttclid",
  "msclkid",
  "_kx",
  "dema_id"
], b = ({
  urlSearchParams: t,
  whitelistedQueryParamKeys: e,
  children: r
}) => {
  const m = (e ?? P).reduce(
    (i, u) => {
      if (t.has(u)) {
        const c = t.get(u);
        c !== null && (i[u] = c);
      }
      return i;
    },
    {}
  ), d = new URLSearchParams(m);
  return /* @__PURE__ */ a(f.Provider, { value: d, children: r });
}, k = () => {
  const t = o(f);
  return t || new URLSearchParams();
}, s = l(void 0), p = (t) => /* @__PURE__ */ a(s.Provider, { value: t, children: t.children });
p.displayName = "LinkProvider";
const g = () => {
  const t = o(s), e = k();
  if (t === void 0)
    throw new Error("useHref must be used within a HrefProvider");
  return v(
    w(t.siteSlug, e),
    [t.siteSlug, e]
  );
}, x = (t) => {
  const e = g(), { LinkComponent: r, ...n } = t;
  return /* @__PURE__ */ a(r, { ...n, href: e(n.href) });
}, y = (t) => {
  const e = o(s);
  if (e === void 0)
    throw new Error("useLink must be used within a LinkProvider");
  const r = e.LinkComponent;
  return /* @__PURE__ */ a(x, { ...t, LinkComponent: r });
}, _ = (t) => {
  const e = o(s);
  if (e === void 0)
    throw new Error("useLink must be used within a LinkProvider");
  const r = e.LinkComponent;
  return /* @__PURE__ */ a(r, { ...t });
}, H = (t = { autoFormatHref: !0 }) => {
  if (o(s) === void 0)
    throw new Error("useLink must be used within a LinkProvider");
  return t.autoFormatHref ? y : _;
}, S = () => {
  const t = o(s);
  if (t === void 0)
    throw new Error("useNavigate must be used within a LinkProvider");
  return t.navigate;
};
export {
  x as HrefFormattingLink,
  p as LinkProvider,
  b as WhitelistedQueryParamsProvider,
  L as constructInternalLink,
  P as defaultWhitelistedQueryParamKeys,
  w as getHrefFormatter,
  s as linkContext,
  g as useHref,
  H as useLink,
  S as useNavigate,
  k as useWhitelistedQueryParams
};
